import { CasesBoard } from '@lp/features/CasesBoard';
import { CasesBoardFilterPanel } from '@lp/features/CasesBoard/components/CasesBoardFilterPanel';
import { CasesBoardControlPanel } from '@lp/features/CasesBoard/components/BoardControlPanel/CasesBoardControlPanel';
import styles from './Home.module.scss';

export const Home = () => {
  return (
    <div className={styles.container}>
      <div className="flex justify-between items-center">
        <h2>Manage Cases</h2>
        <CasesBoardControlPanel />
      </div>
      <CasesBoardFilterPanel />
      <CasesBoard />
    </div>
  );
};
